import { render } from "./CategoryMetadataBanner.vue?vue&type=template&id=79de60c9&lang=pug"
import script from "./CategoryMetadataBanner.vue?vue&type=script&lang=js"
export * from "./CategoryMetadataBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__